const state = () => ({
  auth: {
    full_name: "",
    roles: [],
    user_info: []
  },
  modalOn: true,
  loading: false,
  working_times: [],
  notify: {
    fcm_token: "",
    total: 0,
    new_notification: {}
  }
});

const mutations = {
  setPermissions(state, permissions) {
    state.auth.permissions = permissions;
  },

  setRoles(state, roles) {
    state.auth.roles = roles;
  },

  setUserInfo(state, userInfo) {
    state.auth.user_info = userInfo;
  },

  showModal(state) {
    state.modalOn = true;
    let body = document.body;
    body.classList.add("modal-on");
  },
  destroyModal(state) {
    state.modalOn = false;
    let body = document.body;
    body.classList.remove("modal-on");
  },
  showLoading(state) {
    state.loading = true;
  },
  hideLoading(state) {
    state.loading = false;
  },
  setWorkingTimes(state, workingTimes) {
    state.working_times = workingTimes;
  },

  setFcmToken(state, token) {
    state.notify.fcm_token = token;
  },

  destroyFcmToken(state) {
    state.notify.fcm_token = "";
  },

  setNotifyTotal(state, total) {
    state.notify.total = total;
  },

  increaseNotifyTotal(state) {
    state.notify.total++;
  },

  setNewNotification(state, notification) {
    state.notify.new_notification = notification;
  }
};

export default { namespaced: true, state, mutations };
